import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class BlockUnblockUserCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }
  run(user_to_update_id, blocked): Promise<any> { 
    let args = {user_to_update_id: user_to_update_id, blocked: blocked};
    try {
      return this.dispatcher.dispatch('block.unblock.user', args);
    } catch(error) {
      console.error('Error al cambiar el estado de bloqueo del usuario', error);
    }
  }
}
